export const products = [
  {
    title: '酒店',
    desc: '机票折上折，一键比价',
    negativeImage: '/images/pages/tmc/app-gray-1.png',
    activeImage: '/images/pages/tmc/app-primary-1.png',
  },
  {
    title: '火车',
    desc: '多接口渠道火车票查询，预订功能',
    negativeImage: '/images/pages/tmc/app-gray-2.png',
    activeImage: '/images/pages/tmc/app-primary-2.png',
  },
  {
    title: '客服',
    desc: '365*72专属客服，无忧出行',
    negativeImage: '/images/pages/tmc/app-gray-3.png',
    activeImage: '/images/pages/tmc/app-primary-3.png',
  },
  {
    title: '机票',
    desc: '机票折上折，一键比价',
    negativeImage: '/images/pages/tmc/app-gray-4.png',
    activeImage: '/images/pages/tmc/app-primary-4.png',
  },
  {
    title: '用车',
    desc: '全网叫车，速度快费用省',
    negativeImage: '/images/pages/tmc/app-gray-5.png',
    activeImage: '/images/pages/tmc/app-primary-5.png',
  },
  {
    title: '保险',
    desc: '消费有积分，兑换有惊喜',
    negativeImage: '/images/pages/tmc/app-gray-6.png',
    activeImage: '/images/pages/tmc/app-primary-6.png',
  },
]
